<template>
    <div class="modal" :class="[deleteBaseModal ? 'is-active' : '']">
        <div class="modal-background" @click="hideModal"></div>
        <div class="modal-card">
            <header class="modal-card-head" >
                <p class="modal-card-title" v-html="messageTitle"></p>
                <button class="delete" aria-label="close" @click="hideModal"></button>
            </header>
            <section class="modal-card-body" v-html="messageText"></section>
            <footer class="modal-card-foot">
                <button
                    class="button is-danger ok-button-10rem"
                    :class="[isLoading ? 'is-loading' : '']"
                    @click="deleteBase"
                    v-if="okText"
                >
                    {{ okText }}
                </button>
                <button
                    class="button ok-button-10rem"
                    @click="hideModal"
                    v-if="cancelText"
                >
                    {{ cancelText }}
                </button>
                <p v-show="errors.unexpected" class="help is-danger">
                    {{ errors.unexpected }}
                </p>
            </footer>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { closeModalByEsc } from '../mixins/closeModalByEsc.js';

    export default {
        mixins: [closeModalByEsc],
        data() {
            return {
                errors: {},
                isLoading: false,

                okReport: 'База удалена',
                failReport: 'Ошибка удаления базы',

                unblockAttachedBases: unblockAttachedBases,
            }
        },
        computed: {
            ...mapState('baseList', [
                'deleteBaseModal',
                'actions',
                'trans',
                'currentBase',
                'bases'
            ]),
            messageText() {
                let result = false;
                if (this.currentBase.licensing_info) {
                    let statusForDel = this.currentBase.licensing_info.verificationResult.statusForDel;
                    result = this.trans.msg.delete_window[statusForDel].message_text;
                }

                return result;
            },
            messageTitle() {
                let result = '';
                if (this.currentBase.licensing_info) {
                    let statusForDel = this.currentBase.licensing_info.verificationResult.statusForDel;
                    result = this.trans.msg.delete_window[statusForDel].message_title;
                }
                result = result.replace(':base_name', this.currentBase.name);

                return result;
            },
            cancelText() {
                let result = '';
                if (this.currentBase.licensing_info) {
                    let statusForDel = this.currentBase.licensing_info.verificationResult.statusForDel;
                    result = this.trans.msg.delete_window[statusForDel].cancel_text;
                }
                if (this.unblockAttachedBases) {
                    result = 'Cancel';
                }
                return result;
            },
            okText() {
                let result = '';
                if (this.currentBase.licensing_info) {
                    let statusForDel = this.currentBase.licensing_info.verificationResult.statusForDel;
                    result = this.trans.msg.delete_window[statusForDel].ok_text;
                }
                if (this.unblockAttachedBases) {
                    result = 'Ok';
                }
                return result;
            },
        },
        methods: {
            ...mapActions('baseList',
                {
                    hideModal: 'hideDeleteBaseModal',
                    setBaseList: 'setBaseList'
                }
            ),
            deleteBase() {
                let deleteAction = `${this.actions.delete}/${this.currentBase.hash_id}`,
                    requestData = {
                        hash_id: this.currentBase.hash_id
                    };

                this.isLoading = true;
                this.errors = {};

                axios.post(deleteAction, requestData)
                    .then(response => {
                        let updatedList = this.bases.filter(base => {
                            return base.hash_id !== this.currentBase.hash_id;
                        });

                        this.setBaseList(updatedList);

                        this.hideModal();
                        sendGAEvent(this.okReport);
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.errors.unexpected = this.trans.msg.unexpected_error;
                        sendGAError(this.failReport);
                        this.isLoading = false;
                    })
            },
        },
    }
</script>
